export enum StatsObject {
  PLAYER = "PLAYER",
  TEAM = "TEAM",
  LEAGUE = "LEAGUE",
}

export enum StatsGrouping {
  GAME = "GAME",
  SEASON = "SEASON",
  TOTAL = "TOTAL",
}

export enum StatsFormat {
  TOTALS = "TOTALS",
  PER_GAME = "PER_GAME",
  PER_MINUTE = "PER_MINUTE",
  PER_36_MINUTES = "PER_36_MINUTES",
  PER_40_MINUTES = "PER_40_MINUTES",
  PER_48_MINUTES = "PER_48_MINUTES",
  PER_POSSESSION = "PER_POSSESSION",
  PER_100_POSSESSIONS = "PER_100_POSSESSIONS",
}

export enum StatsType {
  BOX_SCORE = "BOX_SCORE",
  ADVANCED = "ADVANCED",
  SHOT_PROFILE = "SHOT_PROFILE",
}
